import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: Home
    },
    { path: '/o-grupo', redirect: '/o-grupo/nossa-historia' },
    { path: '/produtos', redirect: '/produtos/roupeiros' },
    { path: '/lojistas', redirect: '/lojistas/ser-um-afiliado' },
    { path: 'http://www.grupotopazio.com.br/', name: 'Blog' },
    {
        path: '/o-grupo',
        name: 'About',
        component: () =>
            /* eslint-disable func-call-spacing */
            import ('../views/About.vue'),
        children: [{
                path: 'nossa-historia',
                name: 'OurStory',
                component: () =>
                    import ('../views/OurStory.vue')
            },
            {
                path: 'a-topazio',
                name: 'TheTopazio',
                component: () =>
                    import ('../views/TheTopazio.vue')
            }
        ]
    },
    {
        path: '/produtos/:categoria',
        name: 'Products',
        component: () =>
            import ('../views/Products.vue')
    },
    {
        path: '/detalhes/:categoria/:id',
        name: 'Details',
        component: () =>
            import ('../views/Details.vue')
    },
    {
        path: '/onde-comprar',
        name: 'WhereBuy',
        component: () =>
            import ('../views/WhereBuy.vue')
    },
    {
        path: '/lojistas',
        name: 'Logisticians',
        component: () =>
            import ('../views/Logisticians.vue'),
        children: [{
                path: 'ser-um-afiliado',
                name: 'Affiliate',
                component: () =>
                    import ('../views/Affiliate.vue')
            },
            {
                path: 'representantes',
                name: 'Representatives',
                component: () =>
                    import ('../views/Representatives.vue')
            }
        ]
    },
    {
        path: '/fale-conosco',
        name: 'ContactUs',
        component: () =>
            import ('../views/ContactUs.vue')
    },
    {
        path: '/links',
        name: 'Links',
        component: () =>
            import ('../views/Links.vue')
    },
    {
        path: '/catalogos',
        name: 'Catalogs',
        component: () =>
            import ('../views/Catalog.vue')
    },
    {
        path: '/area-dos-representantes',
        name: 'RepresentativesArea',
        component: () =>
            import ('../views/RepresentativesArea.vue')
    },
    {
        path: '*',
        component: Home
    }
]

const router = new VueRouter({
        mode: 'history',
        base: process.env.BASE_URL,
        routes
    })
    /* eslint-disable eol-last */
export default router